import { useEffect, useState } from "react";
import api from "@/lib/apiClient";

/* v11 · Precios del plan Pro/Business y oferta de lanzamiento, editables en el panel admin.
   Si el servidor no responde se usan los precios de siempre (y sin oferta). */
export const DEFAULT_PRICING = {
  pro: { monthly: 57, yearly: 570, yearly_discount: 17 },
  business: { monthly: 197, yearly: 1970, yearly_discount: 17, extra_user_monthly: 35, extra_user_yearly: 350 },
  offer: null,
};

let cache = null;

export function usePricing() {
  const [data, setData] = useState(cache || DEFAULT_PRICING);
  useEffect(() => {
    let alive = true;
    api.get("/pricing").then((r) => { cache = r.data; if (alive) setData(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return data;
}

export const euro = (n) =>
  typeof n === "number" ? n.toLocaleString("es-ES", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) : "—";

/** Precio que se muestra del plan Pro: {now, before} (before solo si hay oferta para ese periodo). */
export function proPrice(pricing, annual) {
  const base = annual ? pricing.pro.yearly : pricing.pro.monthly;
  const o = pricing.offer;
  const offer = o ? (annual ? o.yearly : o.monthly) : null;
  return offer && offer < base ? { now: offer, before: base } : { now: base, before: null };
}
